// import "core-js";
import 'babel-polyfill'
import 'core-js/features/promise';
import 'core-js/features/object/values';
import 'core-js/features/array/includes';

import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import router from './router/router'
import axios from 'axios' 
import api from './api/api'
import utils from './utils/utils'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VueGtag from 'vue-gtag'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Meta from 'vue-meta';

import '@/assets/css/common.css';
import '@/assets/css/fonts.css';
import '@/assets/css/layout.css';
import '@/assets/css/m_common.css';
import '@/assets/css/m_layout.css';
import '@/assets/css/reset.css';
import 'swiper/css/swiper.css';
import 'vue-date-pick/dist/vueDatePick.css';
import 'vue2-timepicker/dist/VueTimepicker.css'

if(process.env.NODE_ENV == 'production') {
   console.log = function(){}
}

Vue.use(Meta);
Vue.use(VueAwesomeSwiper);
Vue.use(VueGtag, {
  config: { id: "G-8NXMHGPZ48" },
  
  // 라우터 이동 시 GA로 보낼 데이터를 가로채서 설정하는 옵션
  pageTrackerTemplate(to) {
    return {
      // 1순위: meta.pageName ('SMS발송')
      // 2순위: name ('my-cstmr-sms-send')
      page_title: to.meta.pageName || to.name, 
      page_path: to.path
    };
  }
}, router); // 👈 여기에 router 객체가 꼭 들어가야 합니다!
Vue.prototype.$axios = axios; // prototype에 axios 추가
Vue.prototype.$api = api;
Vue.prototype.$utils = utils;
Vue.config.productionTip = false;

// 기본 컴포넌트 전역 등록 시작
var requireComponent = require.context(
  // 컴포넌트들이 있는 폴더
  './components/base',
  // 하위 폴더까지 포함할 지 여부
  false,
  // 기본 컴포넌트를 찾는데 사용할 정규표현식
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // 컴포넌트 설정 가져오기
  var componentConfig = requireComponent(fileName)

  // 컴포넌트의 파스칼표기법 이름 가져오기
  var componentName = upperFirst(
    camelCase(
      // 폴더 위치와 무관하게 파일이름 추출
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // 컴포넌트를 전역적으로 등록
  Vue.component(
    componentName,
    // `export default`를 이용한 컴포넌트는 `.default`로 컴포넌트
    // 옵션을 추출하고 그렇지 않은 컴포넌트는 모듈의 루트를 호출
    componentConfig.default || componentConfig
  )
})
// 기본 컴포넌트 전역 등록 종료

var vm = new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')

window.app = vm;

axios.interceptors.request.use(function (config) {
  console.log('axios.interceptors.request', config);
  console.log(config.url, 'blockYn', config.headers.blockYn);
  if(config.headers.blockYn == 'Y') {
    window.app.$emit('request-before');
  }
  return config;
}, function (error) {
  window.app.$emit('request-error');
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  console.log('axios.interceptors.response', response);
  console.log(response.config.url, 'blockYn', response.config.headers.blockYn);
  if(response.config.headers.blockYn == 'Y') {
    window.app.$emit('response-after');
  }
  return response;
}, function (error) {
  window.app.$emit('response-error');
  return Promise.reject(error);
});